export interface MappedHeroVideo {
  videoId?: string
  image?: {
    url: string
    alt: string
    focusArea?: string
  }
}

const resolveVimeoYoutubeVideoUrl = (media: {
  videoReferenceType?: string | null
  videoCode?: string | null
  videoUrl?: string | null
}): string | undefined => {
  if (media.videoReferenceType === "Video Code") {
    return media.videoCode ?? media.videoUrl ?? undefined
  }
  if (media.videoReferenceType === "Video URL") {
    return media.videoUrl ?? media.videoCode ?? undefined
  }
  return media.videoUrl ?? media.videoCode ?? undefined
}

const mapFocalPointThumbnail = (
  thumbnail: {
    image?: { url?: string | null } | null
    altText?: string | null
    focusArea?: string | null
  } | null | undefined,
  fallbackAlt?: string | null,
): MappedHeroVideo["image"] | undefined => {
  if (!thumbnail?.image?.url) return undefined
  return {
    url: thumbnail.image.url,
    alt: thumbnail.altText || fallbackAlt || "",
    focusArea: thumbnail.focusArea || undefined,
  }
}

/** Maps flexibleHero `video` entries to the shape expected by VideoCovered. */
export function mapContentfulVideo(
  entry: { __typename?: string } | null | undefined,
): MappedHeroVideo | undefined {
  if (!entry?.__typename) return undefined

  switch (entry.__typename) {
    case "VideoGeneral": {
      const video = entry as {
        videoUrl?: string | null
        title?: string | null
        videoThumbnail?: {
          image?: { url?: string | null } | null
          altText?: string | null
        } | null
      }
      if (!video.videoUrl) return undefined
      return {
        videoId: video.videoUrl,
        image: mapFocalPointThumbnail(video.videoThumbnail, video.title),
      }
    }
    case "Video": {
      const video = entry as {
        videoTitle?: string | null
        videoReferenceType?: string | null
        videoCode?: string | null
        videoUrl?: string | null
        videoThumbnail?: {
          image?: { url?: string | null } | null
          altText?: string | null
          focusArea?: string | null
        } | null
      }
      const videoId = resolveVimeoYoutubeVideoUrl(video)
      if (!videoId) return undefined
      return {
        videoId,
        image: mapFocalPointThumbnail(video.videoThumbnail, video.videoTitle),
      }
    }
    case "VidyardVideo": {
      const video = entry as {
        uuid?: string | null
        videoTitle?: string | null
        videoThumbnail?: {
          image?: { url?: string | null } | null
          altText?: string | null
          focusArea?: string | null
        } | null
      }
      if (!video.uuid) return undefined
      return {
        videoId: video.uuid,
        image: mapFocalPointThumbnail(video.videoThumbnail, video.videoTitle),
      }
    }
    default:
      return undefined
  }
}
